import React, { PureComponent } from 'react';

class QuestionMark extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <svg
        width="7"
        height="9"
        viewBox="0 0 6 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.57 5.92C3.55 5.73 3.54 5.57 3.54 5.41C3.54 4.88 3.69 4.64 4.32 4.22C5.14 3.66 5.32 3.51 5.55 3.2C5.79 2.87 5.9 2.5 5.9 2.02C5.9 0.84 4.79 0.0199996 3.18 0.0199996C2.24 0.0199996 1.48 0.26 0.97 0.72C0.54 1.11 0.34 1.49 0.18 2.22L1.66 2.4C1.7 2.02 1.76 1.85 1.9 1.65C2.14 1.29 2.57 1.08 3.09 1.08C3.95 1.08 4.48 1.46 4.48 2.07C4.48 2.52 4.24 2.84 3.6 3.27C2.95 3.69 2.87 3.76 2.66 4.02C2.38 4.37 2.25 4.78 2.25 5.31L2.26 5.5C2.26 5.63 2.25 5.75 2.23 5.92H3.57ZM2.17 6.75V8.12H3.62V6.75H2.17Z"
          fill="white"
        />
      </svg>
    );
  };
}

export default QuestionMark;
